import {
  Target, Flame, CalendarCheck, CheckCircle2, BookOpenCheck, CreditCard, Radio, Mic, Compass,
  ThumbsUp, MessageCircle, Sparkles, Award, Medal, Trophy, Crown, PenLine, Link2,
} from "lucide-react";

export const BADGE_ICONS = {
  Target, Flame, CalendarCheck, CheckCircle2, BookOpenCheck, CreditCard, Radio, Mic, Compass,
  ThumbsUp, MessageCircle, Sparkles, Award, Trophy, Crown, PenLine, Link2,
};

export const badgeIcon = (name) => BADGE_ICONS[name] || Medal;

export const TIER_STYLES = {
  1: "bg-amber-50 border-amber-200 text-amber-800",
  2: "bg-slate-100 border-slate-300 text-slate-700",
  3: "bg-yellow-100 border-yellow-400 text-yellow-800",
};

export const CATEGORY_KEYS = {
  attendance: "badge_cat_attendance",
  homework: "badge_cat_homework",
  payments: "badge_cat_payments",
  community: "badge_cat_community",
  special: "badge_cat_special",
};
